/**
 * BCP 47 - Best Coding Practice 47 standard used for language locale IDs
 *
 * Read please:
 *
 * - https://learn.microsoft.com/en-us/openspecs/office_standards/ms-oe376/6c085406-a698-4e12-9d4d-c3b0ee3dbc4a
 * - https://www.rfc-editor.org/info/bcp47
 * - https://angular.io/guide/i18n-common-locale-id
 */
export enum LanguageCode {
  EN_GB = 'en-GB',
  DE_DE = 'de-DE',
  ES_ES = 'es-ES',
  IT_IT = 'it-IT',
  FR_FR = 'fr-FR',
  DE_CH = 'de-CH',
  CS_CZ = 'cs-CZ',
  NL_BE = 'nl-BE',
}

export type LanguageCodes = `${LanguageCode}`;
